<header [ngClass]="{ 'layer-loading': layersAreLoading() }">
    <div
        class="import-file-heading"
        title="{{ currentMapWorkspace.connectFileName }}"
        *ngIf="currentMapWorkspace.isFileViewer"
    >
        {{ currentMapWorkspace.connectFileName | uppercase }}
    </div>
    <h2 *ngIf="!currentMapWorkspace.isFileViewer" translate="data"></h2>
    <div class="layer-view" [ngClass]="{ hide_layer: !visibleAll }" (click)="toggleAll()">
        <i
            class="i24"
            [ngClass]="{ icon_line_visibility_show: visibleAll, icon_line_visibility_hide: !visibleAll }"
        ></i>
    </div>
</header>

<custom-scroll class="layer-list-content height-full">
    <ul class="layers-list">
        <li *ngIf="loading">
            <loading class="width-full" [small]="true"></loading>
        </li>
        <ng-container *ngIf="!loading">
            <ng-container *ngIf="!layers.length">
                <li
                    class="no-hover"
                    *checkVisibility="{
                        visibleModes: [
                            MapWorkspacePermissionType.READ,
                            MapWorkspacePermissionType.FULL_ACCESS,
                            MapWorkspacePermissionType.NO_ACCESS
                        ]
                    }"
                >
                    {{ 'TCS.Mapviewer.AddMenu.PressToAddData' | translate }}
                </li>
                <li class="no-hover" *checkVisibility="{ visibleModes: [MapWorkspacePermissionType.FILE_VIEW_MODE] }">
                    {{ 'TC.Common.NoPreviewableData' | translate }}
                </li>
            </ng-container>

            <li
                class="fade-in fade-out layer-container"
                *ngFor="let layer of layers; index as i"
                [ngClass]="{
                    selected: layer.selected,
                    'layer-loading': isDisabled(layer),
                    locked: layer.isLocked
                }"
            >
                <div
                    class="layer-list-item-container"
                    (contextmenu)="layerListContextMenu.onContextMenu($event, layer)"
                >
                    <div class="sub-layer-drop">
                        <i
                            class="i24"
                            [ngClass]="{
                                icon_line_arrow_up: layerSublayersDropVisibleMap.get(layer.id),
                                icon_line_arrow_down: !layerSublayersDropVisibleMap.get(layer.id)
                            }"
                            *ngIf="layerSymbologyOverridesMap.get(layer.id)?.length"
                            (click)="toggleSublayersDrop(layer.id)"
                        ></i>
                    </div>
                    <div class="layer-geom">
                        <div
                            class="badge--old"
                            *ngIf="layer.nonSpatialCount > 0"
                            title="{{ 'TCS.Mapviewer.LayerContextMenu.SelectFormNoLocation' | translate }}"
                            tooltipLocation="right"
                            data-tooltip-show-always="true"
                            (click)="addNonSpatialToPanel(layer)"
                        >
                            {{ layer.nonSpatialCount }}
                        </div>
                        <geom-icon
                            *ngIf="!layer.layerIsBeingDuplicated"
                            [path]="'symbol_24-preview-'"
                            [color]="layer.color"
                            [outlineColor]="getLayerOutlineColor(layer)"
                            [geoType]="
                                layerSublayersDropVisibleMap.get(layer.id) ? GeometryTypes.PLANE : layer.geometryType
                            "
                            [svgIcon]="layer.style.symbol?.svgImage"
                            [symbolType]="layer.style.symbol?.type"
                            [symbolText]="layer.style.symbol?.text"
                            [lineStyle]="layer.style.lineStyle"
                            [polygonOpacity]="layer.style.fillOpacity"
                            addLayerBasePolygon="true"
                            id="{{ layer.id }}"
                            (click)="
                                currentMapWorkspace.type !== WorkspaceType.SURVEY &&
                                    !isDisabled(layer) &&
                                    goToEditModal(layer)
                            "
                        ></geom-icon>
                    </div>
                    <i class="lock-template" *ngIf="layer.isLocked"></i>
                    <img
                        class="layer-pending-icon"
                        title="{{ 'TCS.Import.Assimilating' | translate }}"
                        tooltipLocation="right"
                        *ngIf="layer.layerIsBeingDuplicated"
                        height="16"
                        width="24"
                        src="assets/images/loading_spinner.svg"
                    />
                    <div class="layer-title" (click)="zoomToLayerExtents(layer)">
                        <div class="layer-name" [attr.title]="layer.layerName" [innerText]="layer.layerName"></div>
                        <div
                            *ngIf="!layer.templatePublishStatus && layer.templateId"
                            translate="TC.Common.DraftTemplate"
                            class="layer-status"
                        ></div>
                        <div *ngIf="layer.workspaces.length > 1" class="layer-status">
                            <i class="icon_line_link i16 linked-icon"></i>
                            <span translate="TC.Common.Linked"></span>
                        </div>
                    </div>
                    <ng-container *ngIf="layer.templateId">
                        <div
                            class="layer-edit"
                            *checkVisibility="{
                                visibleModes: [MapWorkspacePermissionType.FULL_ACCESS],
                                visibleOnlyFor: [WorkspaceType.GIS]
                            }"
                            (click)="!isDisabled(layer) && goToTemplateEditor(layer)"
                        >
                            <div translate="TCW_Edit"></div>
                            <i
                                class="draft-icon"
                                *ngIf="!layer.templatePublishStatus && layer.templateVersionId == 1"
                            ></i>
                            <i
                                class="template-draft-icon"
                                *ngIf="!layer.templatePublishStatus && layer.templateVersionId > 1"
                            ></i>
                            <i class="template-icon" *ngIf="layer.templatePublishStatus"></i>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="showCreateTemplateAction(layer)">
                        <div
                            class="layer-edit"
                            *checkVisibility="{
                                visibleModes: [MapWorkspacePermissionType.FULL_ACCESS],
                                visibleOnlyFor: [WorkspaceType.GIS]
                            }"
                            (click)="!isDisabled(layer) && layerToTemplate(layer)"
                        >
                            <div translate="TC.Common.Add"></div>
                            <i class="template-add-icon i24"></i>
                        </div>
                    </ng-container>
                    <div class="layer-view" [ngClass]="{ hide_layer: !layer.visible }" (click)="toggle(i)">
                        <i
                            class="i24"
                            [ngClass]="{
                                icon_line_visibility_show: layer.visible,
                                icon_line_visibility_hide: !layer.visible
                            }"
                        ></i>
                    </div>

                    <gsp-context-menu #layerListContextMenu [items]="contextMenuItems"></gsp-context-menu>
                </div>

                <!-- Sub-layers for Style Symbology -->

                <ng-container *ngIf="layerSublayersDropVisibleMap.get(layer.id)">
                    <div
                        class="sub-layers-container"
                        *ngFor="let sublayer of layerSymbologyOverridesMap.get(layer.id)"
                        @dropDown
                    >
                        <div class="sublayer-list-item-container" (contextmenu)="$event.preventDefault()">
                            <geom-icon
                                *ngIf="!layer.layerIsBeingDuplicated"
                                [path]="'symbol_24-preview-'"
                                [color]="getSublayerFillColor(layer, sublayer)"
                                [outlineColor]="getSublayerOutlineColor(layer, sublayer)"
                                [geoType]="layer.geometryType"
                                [svgIcon]="layer.style.symbol?.svgImage"
                                [symbolType]="layer.style.symbol?.type"
                                [symbolText]="layer.style.symbol?.text"
                                [lineStyle]="layer.style.lineStyle"
                                [polygonOpacity]="layer.style.fillOpacity"
                                id="{{ layer.id }}"
                                size="20"
                            ></geom-icon>
                            <div class="layer-title" (click)="zoomToLayerExtents(layer)">
                                <div
                                    class="layer-name"
                                    title="{{ sublayer.choiceDisplayValue || sublayer.choiceValue }}"
                                >
                                    {{ sublayer.choiceDisplayValue || sublayer.choiceValue }}
                                </div>
                            </div>
                            <div
                                class="layer-view"
                                [ngClass]="{ hide_layer: !sublayersVisibleMap.get(sublayer.id) }"
                                (click)="toggleSublayer(layer, sublayer)"
                            >
                                <i
                                    class="i24"
                                    [ngClass]="{
                                        icon_line_visibility_show: sublayersVisibleMap.get(sublayer.id),
                                        icon_line_visibility_hide: !sublayersVisibleMap.get(sublayer.id)
                                    }"
                                ></i>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </li>
        </ng-container>
    </ul>

    <map-cache-list></map-cache-list>
</custom-scroll>

<ng-container *checkVisibility="{ visibleOnlyFor: [WorkspaceType.GIS] }">
    <div
        class="tip"
        *ngIf="!isTemplateLayerExist() && layers.length && !tooltipClosed && !currentMapWorkspace.isFileViewer"
    >
        <i class="i16 icon_line_x" (click)="tooltipClosed = true"></i>
        <div>
            <span>{{ 'TC.Common.Tip' | translate }}</span
            >:&nbsp;{{ 'TCS.Mapviewer.LayerPanel.AddTemplateTip' | translate }}
        </div>
        <img src="assets/images/no-template-tip.png" alt="" />
    </div>
</ng-container>
<footer>
    <upload-status *ngIf="currentMapWorkspace.id && !currentMapWorkspace.isPubliclySharedMapWorkspace"></upload-status>
    <fileviewer-upload-status *ngIf="currentMapWorkspace.isFileViewer"></fileviewer-upload-status>
    <map-provider-list></map-provider-list>
    <add-menu
        *ngIf="currentMapWorkspace && currentMapWorkspace.type !== WorkspaceType.SURVEY"
        [showAddDataTip]="!loading && !layers.length"
    ></add-menu>
</footer>
